import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { useEffect } from "react";
import smoothscroll from "smoothscroll-polyfill";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			networkMode: "always",
			staleTime: 5_000,
			cacheTime: Infinity,
			retry: false,
		},
		mutations: {
			networkMode: "always",
			cacheTime: 0,
			retry: false,
		},
	},
});

const persister = createSyncStoragePersister({
	storage: typeof window !== "undefined" ? window.sessionStorage : undefined,
});

export const QueryProvider = ({ children }) => {
	useEffect(() => {
		smoothscroll.polyfill();
	}, []);

	return (
		<PersistQueryClientProvider
			client={queryClient}
			persistOptions={{
				persister,
				maxAge: Infinity,
				dehydrateOptions: {
					shouldDehydrateQuery: (query) =>
						query.state.status === "success" &&
						query.queryKey[0] !== "customer",
				},
			}}>
			{children}
		</PersistQueryClientProvider>
	);
};
